import classnames from 'classnames'

import { RichText, RichTextProps } from '../../molecules'

import styles from './richtextSectionWithBorder.module.scss'

export interface RichtextSectionWithBorderProps {
  description?: RichTextProps | undefined
  className?: string
}

export const RichtextSectionWithBorder = ({ className = '', ...props }: RichtextSectionWithBorderProps) => {
  const wrapClassnames = classnames(styles.richtextSectionWithBorderWrap, className)

  return (
    <div className={wrapClassnames}>
      {props.description && (
        <RichText
          {...props.description}
          className={classnames(styles.richtextSectionWithBorderDescription, className)}
        />
      )}
    </div>
  )
}

export default RichtextSectionWithBorder
